module.exports = __webpack_public_path__ + "static/savage-squid-logo-8a2b1d202ee30ff7f646b6edc5149dff.png";